import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { webApi } from 'src/app/api';
import { AppService } from 'src/app/app.service';
import { ActiveDeleteDialogComponent } from '../../special-offers/active-delete-dialog/active-delete-dialog.component';

export interface Plan {
  _id: string;
  createdAt: Date;
  name: String;
  subType:String;
  // description: String;
  rzpPlanId: String;
  listingPrice: number;
  sellingPrice: number;
  isActive: boolean;
  isPopular: boolean;
}
@Component({
  selector: 'app-list-plan',
  templateUrl: './list-plan.component.html',
  styleUrls: ['./list-plan.component.scss'],
})
export class ListPlanComponent implements OnInit {
  isLoading: boolean = false;
  userDetails: any;
  httpHeaders: any;
  magazineDetails: any;

  constructor(
    public as: AppService,
    private matDialog: MatDialog,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('TGV2WebAdminDetails')!);
    this.httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${this.userDetails['accessToken']}`,
    });
    this.fetchPlan();
  }

  isAddEditCalled: boolean = false;
  dataToEdit: any;
  p: any = 1;
  count: any = 50;

  opened: boolean = false;
  modeNum: number = 0;
  positionNum: number = 0;
  dock: boolean = false;
  closeOnClickOutside: boolean = false;
  closeOnClickBackdrop: boolean = true;
  showBackdrop: boolean = false;
  animate: boolean = true;
  trapFocus: boolean = true;
  autoFocus: boolean = true;
  keyClose: boolean = false;
  toggleSortDiv: boolean = false;
  downloadReport: boolean = false;

  listOfPlanToDisplay: Array<Plan> = [];
  listOfPlan: Array<Plan> = [];
  listOfPlanOriginal: any = [];
  listOfProduct: any = [];
  listOfCategory: any = [];

  myHeaders = new Headers();

  async fetchPlan() {
    this.isLoading=true;
    this.listOfPlanToDisplay = [];
    try {
      let URL = '';

      URL = `${webApi.domain + webApi.endPoint.fetchPlans}`;

      await this.as
        .fetchDetail({ admin: true }, URL, this.httpHeaders)
        .then((data: any) => {
          if (data['success']) {
            this.listOfPlanToDisplay = data['result'];
            this.listOfPlan = [...this.listOfPlanToDisplay];
            this.isLoading = false;
          } else {
            this.listOfPlanToDisplay = [];
            this.listOfPlan = [];
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.listOfPlanToDisplay = [];
      this.listOfPlan = [];
      this.isLoading = false;
    }
  }

  searchData(target: any) {
    console.log(target.value);
    let serachQuery = target.value;
    if (serachQuery != '') {
      let tempSearchList: any = [];
      this.listOfPlanToDisplay = [];
      this.listOfPlan.forEach((plan: any, index: number) => {
        if (
          String(plan.language)
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase()) ||
          String(plan.categoryId.name)
            .toLowerCase()
            .includes(String(serachQuery).toLowerCase())
        ) {
          tempSearchList.push(plan);
        }
      });
      this.listOfPlanToDisplay = tempSearchList;
    } else {
      this.listOfPlanToDisplay = [];
      this.listOfPlanToDisplay = this.listOfPlan;
    }
  }

  updateActiveStatus(plan: Plan, isActive: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { plan: plan, source: 'Active Plan' };

    let dialogRef = this.matDialog.open(
      ActiveDeleteDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      if (res == null) {
        return;
      } else {
        const param = {
          planId: res['value']['_id'],
          action: 'Status',
          isActive: isActive,
        };

        const URL = `${
          webApi.domain + webApi.endPoint.updateActiveOrDeleteStatusPlan
        }`;
        await this.as
          .updateDataViaPut(param, URL, this.httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              this.listOfPlanToDisplay.forEach((plan: any, index: number) => {
                if (plan['_id'] == res['value']['_id']) {
                  plan.isActive = isActive;
                }
              });
              this.listOfPlan = [...this.listOfPlanToDisplay];
              if (isActive) {
                this.showSuccessToaster(
                  'Plan Activated Successfully',
                  'Success'
                );
              } else {
                this.showSuccessToaster(
                  'Plan Inactivated Successfully',
                  'Success'
                );
              }
            } else {
              this.showErrorToaster(
                'Error Occurred while updating plan. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  deletePlan(plan: Plan) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { plan: plan, source: 'Delete Plan' };

    let dialogRef = this.matDialog.open(
      ActiveDeleteDialogComponent,
      dialogConfig
    );
    dialogRef.updatePosition(dialogConfig.position);
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
      }
    });
    dialogRef.componentInstance.closeActivityAtDialog.subscribe(async (res) => {
      if (res == null) {
        return;
      } else {
        const param = {
          planId: res['value']['_id'],
          action: 'Delete',
        };

        const URL = `${
          webApi.domain + webApi.endPoint.updateActiveOrDeleteStatusPlan
        }`;
        await this.as
          .updateDataViaPut(param, URL, this.httpHeaders)
          .then((data: any) => {
            if (data['success']) {
              let index = 0;
              this.listOfPlanToDisplay.forEach((plan: any, i: number) => {
                if (plan['_id'] == res['value']['_id']) {
                  index = i;
                }
              });
              this.listOfPlanToDisplay.splice(index, 1);
              this.listOfPlan = [...this.listOfPlanToDisplay];

              this.showSuccessToaster('Plan Deleted Successfully', 'Success');
            } else {
              this.showErrorToaster(
                'Error Occurred while deleting plan. Try again',
                'Error'
              );
            }
          });
      }
    });
  }

  addNewPlan() {
    this.toggleOpened();
  }

  editPlan(magazine: any) {
    let magazineToEdit;
    this.listOfPlanToDisplay.forEach((mgz: any) => {
      if (mgz['_id'] == magazine._id) {
        magazineToEdit = mgz;
      }
    });
    this.dataToEdit = magazineToEdit;
    this.toggleOpened();
  }

  showSuccessToaster(message: string | undefined, title: string | undefined) {
    this.toastr.success(message, title);
  }
  showErrorToaster(message: string | undefined, title: string | undefined) {
    this.toastr.error(message, title);
  }

  toggleOpened(): void {
    this.isAddEditCalled = true;
    this.opened = !this.opened;
  }
  toggleClose(event: any): void {
    this.opened = !this.opened;
    this.isAddEditCalled = false;
    this.isLoading = true;
    if (event != null) {
      if (event == 'Error') {
        if (this.dataToEdit != null) {
          this.showErrorToaster(
            'Error while editing user details.Kindly try again',
            'Error'
          );
        } else {
          this.showErrorToaster(
            'Error while adding user details.Kindly try again',
            'Error'
          );
        }
        this.dataToEdit = null;
        this.isLoading = false;
        return;
      } else {
        const index = this.listOfPlanToDisplay.findIndex(
          (plan: any) => plan['_id'] == event['_id']
        );

        if (index == -1) {
          this.listOfPlanToDisplay.push(event);
          this.listOfPlan = [...this.listOfPlanToDisplay];
          this.showSuccessToaster('Plan added successfully', 'Success');
        } else {
          this.listOfPlanToDisplay[index] = event;
          this.listOfPlan = [...this.listOfPlanToDisplay];
          this.showSuccessToaster('Plan Updated successfully', 'Success');
        }
        this.dataToEdit = null;
        this.isLoading = false;
        return;
      }
    }

    this.dataToEdit = null;
    this.isLoading = false;
  }

  onBackdropClicked(): void {
    console.info('Backdrop clicked');
  }

  selectStatus(target: any) {
    this.listOfPlanToDisplay = [];
    let value = target.value;
    if (value == 'All') {
      this.listOfPlanToDisplay = this.listOfPlan;
    } else {
      this.listOfPlanToDisplay = this.listOfPlan.filter(
        (data: any) => data.name == value
      );
    }
  }
}
